import {
  getStaffsByEstaId,
  getStaffById,
  setStaff,
  getMappedStaffs,
  setMappingStaff
} from '../api/staffs';


function OrderByFullName(a, b){

  const nameA = a.fullname.toUpperCase(); // ignore upper and lowercase
  const nameB = b.fullname.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
}

export async function getStaffsForEstablishment(estaId) {
  return getStaffsByEstaId(estaId);
}

export async function getStaff(estaId, id) {
  const staff = await getStaffById(estaId, id);
  if (staff) {
    if ( staff.jobs.length < 1) staff.job = {}
    else staff.job = staff.jobs[0]

    staff.job_identification = staff.job?.job_identification;
  }
  return staff;
}

export async function updateStaff(estaId, staff){
  delete staff.establishments;
  delete staff.jobs;
  delete staff.job_identification;
  delete staff.staf_readonly;
  const st = { ...{esta_id: estaId}, ...staff,  };
  return setStaff(st)
}

export async function MappedStaffs(estaId, cntId){
  const data  = await getMappedStaffs(estaId, cntId);
  if (data) {

   const result = data.map(p=>{
     p.fullname = `${p.staf_lastname} ${p.staf_firstname}`;
     p.saved = (p.ext_uri !== null);
     return p;
   })
 
    return result.sort(OrderByFullName);
  }
 }
 
 export async function SetStaffUri(estaId, cntId, sestId, uri){
   const data = await setMappingStaff({esta_id: estaId, cnt_id: cntId, sest_id: sestId, ext_uri: uri});
 
   if (data && data?.seec_id > 0) return true;
 
   return false;
 }